const stats = [
  { value: '3,200+', label: 'Active Businesses', icon: 'ri-store-2-line' },
  { value: '480K+', label: 'Ads Generated', icon: 'ri-flashlight-line' },
  { value: '14', label: 'Ad Platforms Supported', icon: 'ri-layout-grid-line' },
  { value: '4.9★', label: 'Average User Rating', icon: 'ri-star-smile-line' },
];

export default function AboutStats() {
  return (
    <section className="py-20 bg-stone-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block text-orange-400 text-xs font-bold uppercase tracking-widest mb-3">
            By the Numbers
          </span>
          <h2 className="text-3xl md:text-4xl font-black text-white">
            Growing fast. Delivering results.
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((s) => (
            <div
              key={s.label}
              className="bg-white/5 border border-white/10 rounded-2xl p-8 text-center hover:border-orange-500/40 transition-all duration-300 group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-orange-500/15 mx-auto mb-4 group-hover:bg-orange-500/25 transition-colors duration-300">
                <i className={`${s.icon} text-orange-400 text-xl`} />
              </div>
              <div className="text-4xl font-black text-white mb-1">{s.value}</div>
              <div className="text-sm text-stone-400 font-medium">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
